import {DeleteButton} from "../../components/DeleteButton.jsx"

export const DeleteSubscriptionButton = ({deleteMutation, id, filePrefixName}) => <DeleteButton
    deleteMutation={deleteMutation}
    apiParameters={{id: id}}
    filePrefixName={filePrefixName}
/>
